module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/comprehendmedical-2018-10-30.paginators.json
// module id = 574
// module chunks = 0